<template>
  <byted-select
    class="report-select"
    :placeholder="placeholder"
    :value="value"
    :multiple="multiple"
    :collapseTags="multiple"
    :disabled="disabled"
    :filterable="filterable"
    :clearable="clearable"
    :size="size"
    @change="selectChangeHandler"
  >
    <byted-option
      v-for="option in optionList"
      :key="option.value"
      :value="option.value"
    >
      {{option.text}}
    </byted-option>
  </byted-select>
</template>

<script>
// 由外部控制状态
export default {
  name: 'report-select',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    optionList: {
      type: Array | Object,
      default: () => []
    },
    value: {
      type: Number | Array,
      default: '',
    },
    placeholder: {
      type: String,
      default: $bp_t('请选择', 'common.please_choose')
    }
  },
  methods: {
    selectChangeHandler(val) {
      this.$emit('valueChanged', val);
    }
  }
};
</script>

<style lang="scss" scoped>
.report-select {
  width: 210px;
  height: 34px;
}
</style>